import { useCreateBuildingGroup } from '../../../../BuildingGroup'
import { createDocFlow, useCreateDocFlow } from '../../../../DocFlow'
import {
  EMAIL_CREATION_FORM_TEMPLATE_FOLDER_PRIVATE,
  isDirtyEmailCreationForm,
  useSendEmail,
} from '../../../../Email'
import { useCreatePost } from '../../../../Post'
import { useCreateRequest } from '../../../../Request'
import { LAYOUT_HEADER_ADD_ENTITY_BUTTON_OPTION_VALUE } from '../../LayoutHeaderAddEntityButton.constants'

export function useHandleSelectAddEntityOption({
  closeEmailFormModal,
  closeModal,
  closeRequestFormModal,
  setEmailFormModal,
  setModal,
  setRequestFormModal,
}) {
  const { handleOpenCreation: handleOpenCreationBuildingGroup } =
    useCreateBuildingGroup({
      setModal,
      onClose: closeModal,
    })

  const { handleOpenCreation: handleOpenCreationPost } = useCreatePost({
    setModal,
    onClose: closeModal,
  })

  const { handleOpenCreation: handleOpenCreationRequest } = useCreateRequest({
    setModal: setRequestFormModal,
    onClose: closeRequestFormModal,
  })

  const { handleOpenCreation: handleOpenCreationDocFlow } = useCreateDocFlow({
    setModal,
    onClose: closeModal,
    onSubmit: createDocFlow,
  })

  const { handleOpenCreationEmail } = useSendEmail({
    getIsDirty: isDirtyEmailCreationForm,
    massMailing: false,
    singleTemplateFolder: EMAIL_CREATION_FORM_TEMPLATE_FOLDER_PRIVATE,
    onCloseEmailFormModal: closeEmailFormModal,
    onCloseModal: closeModal,
    onSetEmailFormModal: setEmailFormModal,
    onSetModal: setModal,
  })

  function handleSelectItem(option) {
    switch (option.value) {
      case LAYOUT_HEADER_ADD_ENTITY_BUTTON_OPTION_VALUE.buildingGroup:
        handleOpenCreationBuildingGroup()
        break
      case LAYOUT_HEADER_ADD_ENTITY_BUTTON_OPTION_VALUE.docFlow:
        handleOpenCreationDocFlow()
        break
      case LAYOUT_HEADER_ADD_ENTITY_BUTTON_OPTION_VALUE.email:
        handleOpenCreationEmail()
        break
      case LAYOUT_HEADER_ADD_ENTITY_BUTTON_OPTION_VALUE.file:
        break
      case LAYOUT_HEADER_ADD_ENTITY_BUTTON_OPTION_VALUE.post:
        handleOpenCreationPost()
        break
      case LAYOUT_HEADER_ADD_ENTITY_BUTTON_OPTION_VALUE.serviceRequest:
        handleOpenCreationRequest()
        break

      default:
        break
    }
  }

  return handleSelectItem
}
